<template>
  <div class="header-wrap">
    <div class="for-blur-border"></div>
    <div class="header flex-box">
        <!-- 左侧返回按钮 -->
        <div class="header-left flex-1 back" @click="back()">
            <i class="iconfont icon-jiantou-copy"></i>
        </div>
        <!-- 首页logo -->
        <div class="header-logo" v-if="!notIndex">
          <div class="logo">
            <img src="/static/img/logo.svg" alt=""/>
            <span class="label">学院</span>
          </div>
        </div>
        <!-- 列表页搜索 -->
        <div class="header-middle" v-else>
<!--            <a :href="'http://m.breadoffer.com/search.html?back=college&path=' + path">-->
<!--              <span class="iconfont icon-sousuo"></span>-->
<!--              <i class="val">{{inputVal}}</i>-->
<!--            </a>-->
        </div>
        <!-- 右侧菜单按钮 -->
        <div class="header-right flex-1">
            <span class="iconfont menu" id="menuLockerBtn">&#xe601;</span>
        </div>
        <!-- 右侧菜单 -->
        <v-menu></v-menu>
    </div>
  </div>
</template>

<script>
  import Menu from 'components/menu/menu'; // 右侧菜单

  export default {
    data() {
      return{
        inputVal:'请输入关键词搜索', // 搜索页中回填到搜索框的文字
        notIndex:true, // 用于控制头部显示logo还是搜索框
        path:'', // 传递给搜索页的来源路径
      }
    },
    components: {
      'v-menu':Menu
    },
    methods:{
      changeHeader() {
        this.notIndex = window.location.href.indexOf('list') != -1;  // 首页是logo，列表页是搜索框
      },
      back(){
        if (window.history.length >= 2) {
            window.history.go(-1);
            return false;
        }
        window.location.href = 'http://m.college.breadoffer.com';
      }
    },
    mounted(){
      // 搜索页中关键词回填
      if(window.location.href.indexOf('keywords') !== -1){
        this.inputVal =  decodeURIComponent(this.GetQueryString('keywords'));
      };
      if(window.location.href.indexOf('source') !== -1){
        this.path = this.GetQueryString('source');
      }
      this.changeHeader();
    }
  }
</script>

<style scoped lang="scss">
@import  "../../sass/mixin";

/*头部样式开始*/
.for-blur-border {
  position: fixed;
  width: 100%;
  height: 0.04rem;
  background-color: #222;
  left: 0;
  top: 0;
  z-index: 1000;
}
.header{
	height:0.46rem;
	background: #fff;
	line-height: 0.46rem;
	color:#333;
	position: fixed;
	left:0;
	top:0.04rem;
	width:100%;
	z-index: 110;
  border-bottom:1px solid #eee;
  @include flex-box();
  // 头部左侧
  .header-left {
  	text-align: center;
    @include flex-1();

    i {
    	display: inline-block;
    	font-size: 0.20rem;
    	color: #222;
    	transform:rotate(180deg);
    }
  }
  // 列表页头部中间
  .header-middle {
  	width: 2.30rem;
  	height: 0.30rem;
  	line-height: 0.30rem;
  	border-radius: 0.03rem;
  	//background-color: #F5F5F5;
  	margin-top:  0.08rem;

    span {
    	font-size: 0.12rem;
    	margin-left: 0.08rem;
    }

    i {
    	font-size: 0.10rem;
    	color: #999;
    	margin-left: 0.04rem;
    	position: relative;
    	top: -0.01rem;
    }

    a {
    	display: block;
    	width: 100%;
    	height: 100%;
    }
  }
  // 首页头部中间logo
  .header-logo{
    width: 2.20rem;
    line-height: 0.20rem;
    text-align: center;
    .logo{
      position: relative;
      padding-right:.25rem;
      img{
        display: inline-block;
        width:.7rem;
        margin:-.03rem .06rem 0 0;
      }
      .label{
        display: inline-block;
        // width:.34rem;
        // height:.16rem;
        // line-height: .16rem;
        padding:.001rem .08rem;
        font-size: .11rem;
        color:#2f3332;
        background-color: #f4d875;
        border-radius: 3px;
        position: absolute;
        top:27%;
      }
    }
  }

  // 头部右侧
  .header-right {
  	text-align: center;
    @include flex-1();

    span {
    	font-size: 0.20rem;
    	color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// header.vue?2b54fd8c